import React from 'react';
import CuadroTorneosInt from './internacionales/CuadroTorneosInt.js';
import CuadroTiposTorneoOrganizadores from './CuadroTiposTorneoOrganizadores.js';
import HomeTorneosLayout from './HomeTorneosLayout.js';
import * as Confederaciones from '../constantes/Confederaciones.js';
import styles from './HomeTorneosInt.module.css';

const organizadores = [
  { id: 0, nombre: 'FIFA', oficialidad: 3 },
  Confederaciones.CONMEBOL,
  Confederaciones.UEFA,
  Confederaciones.CONCACAF,
  Confederaciones.CAF,
  Confederaciones.AFC,
  Confederaciones.OFC,
];

const HomeTorneosInt = (props) => {
  return (
    <HomeTorneosLayout variant="twoColumnSidebar">
      <div className={`${styles.columnaPrincipal}`}>
        <div className={`${styles.contenedorCuadros}`}>
          {organizadores.map((organizador, index) => (
            <CuadroTorneosInt key={index} organizador={organizador} />
          ))}
        </div>
      </div>
      <div className={`${styles.columnaLateral}`}>
        <CuadroTiposTorneoOrganizadores organizadores={organizadores} />
      </div>
    </HomeTorneosLayout>
  );
};

export default HomeTorneosInt;
